// previously from jslibs
moment = require('moment');
require('jquery' /* 2.2.4 */); // jquery this old doesn't have a proper package.json, so cheat by dropping it in the directory
_ = require('underscore');
require('backbone-1.3.3/backbone');
// end previously from jslibs

require('fastclick');

require('scripts/console-helper');

require('scripts/armusscript');

require('scripts/backbone.marionette');

require('scripts/backbone.controller');

var req = require.context('scripts', true, /^\.\/.*\.js$/);
req.keys().forEach(function(key){
    req(key);
});

require('filesize');

/*
The 12 module requires below are equivalent to simply requiring the main
bootstrap aggregator module:

    require('bootstrap');

They're required individually, however, to allow only including the stuff we
need, and to be able to slice out pieces which create conflicts.
*/
//require('bootstrap/js/transition');
//require('bootstrap/js/alert');
//require('bootstrap/js/button');
//require('bootstrap/js/carousel');
//require('bootstrap/js/collapse');
//require('bootstrap/js/dropdown');
//require('bootstrap/js/modal');
//require('bootstrap/js/tooltip');
//require('bootstrap/js/popover');
//require('bootstrap/js/scrollspy');
//require('bootstrap/js/tab');
//require('bootstrap/js/affix');



//////////////////
// WEBPACK FOOTER
// ./vendor/vendor.js
// module id = 666
// module chunks = 1